import { Injectable, Inject, Injector } from '@angular/core';
import { CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  CanLoad,
  Route,
  Data,
  NavigationStart,
  Event
} from '@angular/router';
import { DOCUMENT } from '@angular/platform-browser';
import { ConfigService } from './config.service';
import { OktaService } from './okta.service';

//@ts-nocheck

@Injectable()
export class OktaGuard implements CanActivate, CanActivateChild, CanLoad {

    private routeData: Data;
    private state: RouterStateSnapshot;
    private onAuthRequired?: any;

    constructor(
        private oktaService: OktaService,
        // private authService: AuthService,
        private injector: Injector,
        private configService: ConfigService,
        @Inject(DOCUMENT) private document: Document
    ) {
        
        if (!this.oktaService.onAuthRequired || !this.oktaService.client) {
            throw new Error('Okta config is not provided');
        }

        this.onAuthRequired = this.oktaService.onAuthRequired;

        const router = injector.get(Router);
        router.events.filter((e: Event) => e instanceof NavigationStart && this.state && this.state.url !== e.url)
        .subscribe(() => {
            this.oktaService.client.authStateManager.unsubscribe(this.updateAuthStateListener);
        });
    }

    setOnAuthRequired(fn: any) {
        this.onAuthRequired = fn;
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        // Track states for current route
        this.state = state;
        this.routeData = route.data;
        this.onAuthRequired = route.data && route.data.onAuthRequired || this.onAuthRequired;
        // Protect the route after accessing
        this.oktaService.client.authStateManager.subscribe(this.updateAuthStateListener);
        const isAuthenticated = await this.isAuthenticated(route.data);
        if (isAuthenticated) {
        return true;
        }

        await this.handleLogin(state.url, route.data);

        return false;
    }

    async canLoad(route: Route): Promise<boolean> {
        return null;
    }

    async canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        return this.canActivate(route, state);
    }

    private async isAuthenticated(routeData?: Data, authState?: any | null) {
        const isAuthenticated = await this.oktaService.client.isAuthenticated();
        // let res = isAuthenticated;
        // // @ts-ignore: Unreachable code error
        // if (routeData?.okta?.acrValues) {
        //   if (!authState) {
        //     authState = this.oktaService.client.authStateManager.getAuthState();
        //   }
        //   res = (authState?.idToken?.claims.acr === routeData?.okta?.acrValues);
        // }
        // return res;

        return isAuthenticated
    }

    private async handleLogin(originalUri?: string, routeData?: Data): Promise<void> {
        // Store the current path
        if (originalUri) {
            this.oktaService.client.setOriginalUri(originalUri);
        }
    
        const options: any = {
            originalUri: `${window.location.origin}`
        };
        // if (routeData?.okta?.acrValues) {
        //   // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //   // @ts-ignore Supports auth-js >= 7.1.0
        //   options.acrValues = routeData.okta.acrValues;
        // }
    
        if (this.onAuthRequired) {
          this.onAuthRequired(this.oktaService.client, this.injector, options);
        } else {
            this.oktaService.client.signInWithRedirect(options);
        }
    }

    private updateAuthStateListener = async (authState: any) => {
        const isAuthenticated = await this.isAuthenticated(this.routeData, authState);
        if (!isAuthenticated) {
          this.handleLogin(this.state.url, this.routeData);
        }
    };

    
}


// WEBPACK FOOTER //
// ./src/app/core/services/okta-guard.service.ts